<template>
    <component v-if="iconComponent" :is="iconComponent" role="img" :fill="color" :height="sizeClass" :width="sizeClass" :class="{'inline-block': true, [iconClass]: true}"></component>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
    },
    iconClass: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      required: false,
      default: 'sm',
      validator(value) {
        return ['xs', 'sm', 'md', 'lg', 'xl'].includes(value);
      },
    },
  },
  computed: {
    sizeClass() {
      return {
        xs: '20',
        sm: '24',
        md: '28',
        lg: '32',
        xl: '36',
      }[this.size];
    },
    iconComponent() {
      // eslint-disable-next-line no-unused-expressions
      this.name;
      return () => import(`!vue-svg-loader!~/../../src/assets/icons/${this.name}.svg`);
    },
  },
};
</script>
